const isMissing = (value) =>
  value === null || value === undefined || String(value).trim() === "" || value === "-";

export const buildQuotaCalculationRequest = (row) => {
  if (isMissing(row?.headerId) || !row?.vendors?.length) {
    throw new Error("A header ID and vendors are required to calculate quota percentages.");
  }

  return {
    headerId: String(row.headerId),
    vendors: row.vendors.map((vendor) => {
      const maxQty = isMissing(vendor.maxQty) ? 0 : Number(vendor.maxQty);
      const quotaPosition = Number(vendor.quotaPosition);
      if (!Number.isFinite(maxQty) || maxQty < 0) {
        throw new Error("Max Qty must be a non-negative number; missing values are treated as 0.");
      }
      if (isMissing(vendor.quotaPosition) || !Number.isInteger(quotaPosition) || quotaPosition < 1) {
        throw new Error("Every vendor must have a valid quota position before calculating.");
      }
      return { quotaPosition, maxQty };
    }),
  };
};

// The calculation response is partial: never replace a full header/vendor with it.
export const applyQuotaCalculationResponse = (row, response) => {
  const result = Array.isArray(response)
    ? response.find((entry) => String(entry.headerId) === String(row.headerId))
    : null;
  if (!result || isMissing(result.totalMaxQty) || !Number.isFinite(Number(result.totalMaxQty))) {
    throw new Error("The calculation API did not return a valid total quantity for this header.");
  }

  const vendors = row.vendors.map((vendor) => {
    const calculated = result.vendors?.find(
      (entry) => Number(entry.quotaPosition) === Number(vendor.quotaPosition),
    );
    if (!calculated || isMissing(calculated.quotaPct) || !Number.isFinite(Number(calculated.quotaPct))) {
      throw new Error("The calculation API did not return a valid quota percentage for every vendor.");
    }
    return {
      ...vendor,
      maxQty: calculated.maxQty ?? vendor.maxQty,
      quotaPct: calculated.quotaPct,
      quotaPercent: calculated.quotaPct,
    };
  });

  return { ...row, totalMaxQty: result.totalMaxQty, vendors };
};